import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    propertyId: '',
    pdpInitData: {},
    isPDPLoading: false,
    error: '',
    isSaved: null,
    onWatchList: false,
    isOwnitNow: false,
    bidCenterData: {},
    investmentInitData: null,
    isNDAAccepted: null,
   
    fcBidCenterData: {},
    bidHistoryData: {},
    userRegisteredForProxyBid: null,
    pdpCMSData: null,
    propertyDetails: {},
    latestBidCenterData: {},
    preferredBidAmount: "",
    preferredOfferAmount: "",
    auctionDetails: {},
    redirectionAction:"",
    redirectionAmount:"",
    offerData:{},
    pdpError:"",
    isCifCompletedForPACT:null,
}

export const pdpSlice = createSlice({
    name: "pdp",
    initialState,
    reducers: {
        fetchPDPInitialLoad: (state, action) => {
            state.isPDPLoading = true;
        },
        fetchInvestCalLoad: (state, action) => {
            state.investmentInitData = null;
        },
        fetchPDPInitialLoadSuccess: (state, action) => {
            state.isPDPLoading = false;
            state.pdpInitData = action.payload;
        },
        fetchInvestmentCalculatorSuccess: (state, action) => {
            state.investmentInitData = action.payload;
        },
        fetchPDPBidCenterData: (state, action) => {
            state.bidCenterData = action.payload;
        },
        fetchPDPLatestBidCenterData: (state, action) => {

            state.latestBidCenterData = action.payload;
        },
        fetchPDPBidCenterDataSuccess: (state, action) => {


            state.bidCenterData = action.payload;
        },
        fetchLatestBidCenterDetailsFaliure: (state, action) => {
            state.bidCenterData = action.payload;
        },
        fetchPDPLatestBidCenterDataSuccess: (state, action) => {
            state.auctionDetails = {
                "auctionEndTime": action.payload.listingEndTime,
                "auctionTimeLeft": action.payload.auctionTimeLeft,
                "bidIncrement": action.payload.bidIncrement,
                "bidIncrementMultiplier": action.payload.customBidIncrementMultiplier,
                "highestBidAmount": action.payload.highestBidAmount,
                "listingStatus": action.payload.listingStatus,
                "maxBidAmount": action.payload.auctionEndTime,
                "minBidAmount": action.payload.auctionEndTime,
                "nextpossibleBidAmount": action.payload.nextpossibleBidAmount,
                "numberOfBids": action.payload.totalBids,
                "reservePriceMet": action.payload.reservePriceMet,
            };
            state.latestBidCenterData = action.payload;
        },
        enableOwnItNow: (state, action) => {
            state.isOwnitNow = action.payload;
        },
        setAuctionDetails: (state, action) => {
            state.auctionDetails = action.payload;;
        },
        setSelectedBidAmount: (state, action) => {
            state.preferredBidAmount = action.payload;;
        },
        setSelectedOfferAmount: (state, action) => {
            state.preferredOfferAmount = action.payload;;
        },
        updateSaveProperty: (state, action) => {
            if (state?.pdpInitData?.propertySpecialDetails?.onWatchList) {
                state.pdpInitData.propertySpecialDetails.onWatchList = action.payload;
            }
        },
        setRedirectionAction: (state, action) => {
            state.redirectionAction = action.payload;;
        },
        setRedirectionAmount: (state, action) => {
            state.redirectionAmount = action.payload;
        },
         setIsNDAAccepted: (state, action) => {
            state.isNDAAccepted = action.payload;;
        },
        resetUserSpecificData: (state) => {
            state.isNDAAccepted = null;
            state.onWatchList = false;
            state.isSaved = null;
            if (state.pdpInitData?.propertySpecialDetails) {
                state.pdpInitData.propertySpecialDetails.onWatchList = false;
            }
        },
        setOfferData : (state,action)=>{
            state.offerData = action.payload
        },
        setPdpError:(state,action)=>{
            state.pdpError = action.payload
            state.isPDPLoading = false
        },
        setIsCifCompletedForPACT:(state,action)=>{
            state.isCifCompletedForPACT = action.payload
        },
        resetPDPState: (state) => {
            return initialState;
        }
    },
});


export const {
    fetchPDPInitialLoad,
    fetchPDPInitialLoadSuccess,
    fetchInvestCalLoad,
    fetchInvestmentCalculatorSuccess,
    fetchPDPBidCenterData,
    fetchPDPLatestBidCenterData,
    fetchPDPBidCenterDataSuccess,
    fetchLatestBidCenterDetailsFaliure,
    fetchPDPLatestBidCenterDataSuccess,
    enableOwnItNow,
    setSelectedBidAmount,
    setSelectedOfferAmount,
    updateSaveProperty,
    setAuctionDetails,
    setRedirectionAction,
    setRedirectionAmount,
    setIsNDAAccepted,
    resetUserSpecificData,
    setOfferData,
    setPdpError,
    setIsCifCompletedForPACT,
    resetPDPState,
} = pdpSlice.actions;
export const pdpData = (state) => (state.pdp)
export default pdpSlice.reducer;
